export default __webpack_public_path__ + "static/hero_sol-86ae03c772d6fda312cd2f3ccf417bbc.jpg";